import React from 'react';
import { ESnapshotExists, EOrganization, exists } from 'lib/types';

import { useBooleanFlag } from 'utils/flags';
import { LaunchDarklyFlags } from 'lib/types/launchDarklyFlags';
import LookerStudioReport from './LookerStudioReport';
import ColumnReports from './ColumnReports';

type ReportsProps = {
  activeOrganization: ESnapshotExists<EOrganization>;
};

function Reports({ activeOrganization }: ReportsProps) {
  const enableColumnReports = useBooleanFlag(
    LaunchDarklyFlags.ENABLE_COLUMN_REPORTS,
    false
  );

  if (!exists(activeOrganization)) return null;

  return (
    <div className="reports-container">
      {enableColumnReports ? (
        <ColumnReports />
      ) : (
        <LookerStudioReport activeOrganization={activeOrganization} />
      )}
    </div>
  );
}

export default Reports;
